import { pipe } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import connectCreateModal from './connectCreateModal'
import connectUpdateModal from './connectUpdateModal'
import RoomModal from './RoomModal'

export const CreateRoomModal = pipe(
  connectCreateModal,
  withTranslation(),
)(RoomModal)

export const UpdateRoomModal = pipe(
  connectUpdateModal,
  withTranslation(),
)(RoomModal)
